module.exports = __webpack_public_path__ + "img/logo-gia.c7498ce.webp";